import { api, http } from "@/lib/http";
import type { FurnitureItem, Room, RoomGenericItem } from "@/types/api";

export interface CreateRoomBody {
  stagingId: number;
  name: string;
  notes?: string;
  orderIndex?: number;
  templateId?: number | null;
}

export interface UpdateRoomBody {
  name: string;
  notes?: string;
  orderIndex?: number;
}

export interface CreatePlaceholderBody {
  name: string;
  notes?: string;
  quantity?: number;
  furnitureCategory?: number | null;
}

export interface UpdatePlaceholderBody {
  name: string;
  notes?: string;
  quantity?: number;
  checked?: boolean;
  replaceItem?: number | null;
  furnitureCategory?: number | null;
}

export interface ReserveFurnitureBody {
  furnitureId: number;
  roomId: number;
  quantity: number;
  notes?: string;
  /** Placeholder these items fill — its slots are consumed by the reservation. */
  placeholderId?: number | null;
}

export interface UpdateReservationBody {
  checked: boolean;
  notes: string;
}

export const roomsApi = {
  list: (stagingId: number) => api.get<Room[]>("/api/rooms", { stagingId }),
  get: (id: number) => api.get<Room>(`/api/rooms/${id}`),
  create: (body: CreateRoomBody) => api.post<Room>("/api/rooms", body),
  update: (id: number, body: UpdateRoomBody) => api.put<Room>(`/api/rooms/${id}`, body),
  remove: (id: number) => api.del<void>(`/api/rooms/${id}`),

  listItems: (roomId: number) => api.get<RoomGenericItem[]>(`/api/rooms/${roomId}/items`),
  createItem: (roomId: number, body: CreatePlaceholderBody) =>
    api.post<RoomGenericItem>(`/api/rooms/${roomId}/items`, body),
  updateItem: (roomId: number, itemId: number, body: UpdatePlaceholderBody) =>
    api.put<RoomGenericItem>(`/api/rooms/${roomId}/items/${itemId}`, body),
  deleteItem: (roomId: number, itemId: number) =>
    api.del<void>(`/api/rooms/${roomId}/items/${itemId}`),

  reserveFurniture: (body: ReserveFurnitureBody) =>
    api.post<FurnitureItem[]>("/api/furniture/reserve", body),

  updateReservation: (roomId: number, itemId: number, body: UpdateReservationBody) =>
    api.put<void>(`/api/rooms/${roomId}/reservations/${itemId}`, body),
};

export const unreserveFurnitureItems = (roomId: number, furnitureItemIds: number[]) =>
  http<void>("/api/rooms/deleteRoomFurnitureItemsHistory", {
    method: "DELETE",
    body: { roomId, furnitureItemIds },
  });

export interface UpdateItemsLocationsBody {
  itemIds: number[];
  roomId?: number | null;
  locationId?: number | null;
}

export const updateFurnitureItemsLocations = (body: UpdateItemsLocationsBody) =>
  http<void>("/api/furnitureItems/locations", {
    method: "PUT",
    body,
  });
